import React from 'react';
import { ModalShell } from '../../../components/ui/ModalFrame';
import LoadingMark from '../../../components/ui/LoadingMark';
import { MODAL_LAYER } from '../../../constants/modalLayers';

/** Full-screen dim + brand mark while a document download (or similar blocking action) is in progress. */
const DownloadDocumentOverlay = ({
  visible,
  message = 'Baixando documento...',
}) => {
  if (!visible) return null;

  return (
    <ModalShell
      backdropPadding="none"
      zClass={MODAL_LAYER.standard}
      backdropClassName="bg-black/50"
      panelClassName="flex flex-col items-center gap-4 bg-transparent shadow-none"
    >
      <LoadingMark size="md" message={message} messageClassName="text-white" />
    </ModalShell>
  );
};

export default DownloadDocumentOverlay;
